import { render, staticRenderFns } from "./DashboardProfileDropdown.vue?vue&type=template&id=79fe1dcf"
import script from "./DashboardProfileDropdown.vue?vue&type=script&lang=js"
export * from "./DashboardProfileDropdown.vue?vue&type=script&lang=js"
import style0 from "./DashboardProfileDropdown.vue?vue&type=style&index=0&id=79fe1dcf&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports